import { Box, Flex, Grid, Text, VisuallyHidden } from "@chakra-ui/react";
import { PROOF_ATTRIBUTION, PROOF_LABEL, PROOF_STATS, type ProofStat } from "@/content";
import { useCountUp } from "@/hooks";

const ProofValue = ({ stat }: { stat: ProofStat }) => {
  const { ref, value } = useCountUp<HTMLElement>(stat.value);

  return (
    <Box as="li" fontSize="small" color="warm.600">
      <Box as="b" ref={ref} fontWeight="normal" color="ink.DEFAULT" sx={{ fontVariantNumeric: "tabular-nums" }}>
        {value}
        {stat.suffix}
      </Box>{" "}
      {stat.label}
    </Box>
  );
};

export const Proof = () => (
  <Grid
    as="section"
    aria-label={PROOF_LABEL}
    maxW="maxw"
    mx="auto"
    px="pad"
    pb="sec"
    gap="18px"
    justifyItems="center"
    textAlign="center"
  >
    <VisuallyHidden as="h2">{PROOF_LABEL}</VisuallyHidden>
    <Text variant="eyebrow">{PROOF_ATTRIBUTION}</Text>
    <Flex as="ul" role="list" wrap="wrap" justify="center" gap="12px clamp(24px, 4vw, 56px)">
      {PROOF_STATS.map((stat) => (
        <ProofValue key={stat.id} stat={stat} />
      ))}
    </Flex>
  </Grid>
);
